/*
    This file contains all the requests available for the locations.
*/
import HttpService from "./http.service";

class LocationService{
    
    // Fetches all locations form the API
    getAllLocations = async () => {
        const endpoint = 'locations';
        return await HttpService.get(endpoint);
    };

    // Fetches a single location by its ID
    getLocationById = async (id) => {
        const endpoint = `locations/${id}`;
        return await HttpService.get(endpoint);
    }

    // Creates a new location
    addLocation = async (location) => {
        const endpoint = 'locations';
        return await HttpService.post(endpoint, location);
    };

    // Updates an existing location
    updateLocation = async (id, location) => {
        const endpoint = `locations/${id}`;
        return await HttpService.patch(endpoint, location);
    };

    // Uploads a locatio image 
    uploadLocationImage = async (formData) => {
        const imageUpdate = `uploads/locations/image`;
        return await HttpService.post(imageUpdate, formData);
    };

    // Fetches the image from the server using the s3Key of the location
    getLocationImage = async (encodedPath) => {
        const endpoint = `uploads/locations/image/${encodedPath}`;
        const response = await HttpService.get(endpoint);
        return response;
    }
}

export default new LocationService();
